export default {
    menuData : [
        {
            name:"Home",
            url:"home",
            iconfont:"icon-home"
        },
        {
            name:"Status",
            url:"status",
            iconfont:"icon-status",
            twoMenu: [
                {
                    name:"WAN",
                    componentName:"wan",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_status_wan_0.png",
                    iconfont:"icon-wan"
                },
                {
                    name:"LAN",
                    componentName:"lan",
                    icon:"img/nav_left/ic_status_lan_0.png",
                    iconfont:"icon-lan"
                },
                {
                    name:"Statistics",
                    componentName:"statistics",
                    icon:"img/nav_left/ic_status_statistics_0.png",
                    iconfont:"icon-statistics"
                },
                {
                    name:"WiFi Neighbor",
                    componentName:"wlanNeighbor",
                    icon:"img/nav_left/ic_wifi_tethering_0.png",
                    iconfont:"icon-neighbor"
                }
            ]
        },
        {
            name:"Basic Setup",
            url:"basicSetup",
            iconfont:"icon-basicSetup",
            twoMenu: [
                {
                    name:"LAN",
                    url:"",
                    icon:"img/nav_left/ic_basic_lan_0.png",
                    iconfont:"icon-lan",
                    thrMenu:[
                        {name:"IPv4 Configuration",componentName:"lanIPv4"},
                        {name:"IPv6 Configuration",componentName:"lanIPv6"}
                    ]
                },
                {
                    name:"WLAN",
                    url:"",
                    icon:"img/nav_left/ic_basic_WLAN_0.png",
                    iconfont:"icon-wifi",
                    thrMenu:[
                        // 双频合一菜单
                        {name:"Basic Config",componentName:"wl1Basic",isBS:true},
                        {name:"Security Setting",componentName:"wl1Security",isBS:true},
                        // 非双频合一菜单
                        {name:"Basic Config 2.4GHz", componentName:"wl1Basic",isBS:false},
                        {name:"Basic Config 5GHz", componentName:"wl0Basic",isBS:false},
                        {name:"Security Setting 2.4GHz",componentName:"wl1Security",isBS:false},
                        {name:"Security Setting 5GHz",componentName:"wl0Security",isBS:false},
                        {name:"Advanced Config 2.4GHz",componentName:"wl1Advanced"},
                        {name:"Advanced Config 5GHz",componentName:"wl0Advanced"},
                        {name:"Guest Wi-Fi",componentName:"wlGuest"}
                    ]
                },
                {
                    name:"NAT",
                    url:"",
                    icon:"img/nav_left/ic_basic_NAT_0.png",
                    iconfont:"icon-nat",
                    thrMenu:[
                        { name: "Port Forwarding", componentName:"portForward",isShowBridge:false},
                        { name: "DMZ Host", componentName:"dmzHost",isShowBridge:false}
                    ]
                },
                {
                    name:"Security",
                    url:"",
                    icon:"img/nav_left/ic_basic_Security_0.png",
                    iconfont:"icon-security",
                    thrMenu:[
                        { name: "IP Filtering", componentName:"ipFilter",isShowBridge:false},
                        { name: "MAC Filtering", componentName:"macFilter",isShowBridge:false},
                        {name:"Parental Controls",componentName:"parentalcontrol",isShowBridge:false}
                    ]
                },
                {
                    name:"Routing",
                    componentName:"routing",
                    icon:"img/nav_left/ic_basic_Routing_1.png",
                    iconfont:"icon-route"
                }
            ]
        },
        {
            name:"Advance Setup",
            url:"advanceSetup",
            iconfont:"icon-advanceSetup",
            twoMenu:[
                {
                    name:"Quality of Service",
                    componentName:"qos",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_advance_settings_applications_0.png",
                    iconfont:"icon-qos"
                },
            ]
        },
        {
            name:"Application",
            url:"application",
            iconfont:"icon-application",
            twoMenu:[
                {
                    name:"Storage Service",
                    url:"",
                    icon:"img/nav_left/ic_appli_device_0.png",
                    iconfont:"icon-storage",
                    thrMenu:[
                        { name: "Device Info", componentName:"deviceInfo"},
                        { name: "User Accounts", componentName:"userAccounts"},
                        { name: "Share Folder", componentName:"shareFolder"},
                        { name: "Samba Server", componentName:"samba"},
                        { name: "FTP Server", componentName:"ftpServer"},
                        {name:"FTP Client",componentName:"ftpClient"},
                        { name: "TFTP Server", componentName:"tftpServer"},
                    ]
                },
                {
                    name:"DLNA",
                    componentName:"dlna",
                    icon:"img/nav_left/ic_appli_DLNA_0.png",
                    iconfont:"icon-dlna"
                },
                {
                    name:"DDNS",
                    componentName:"ddns",
                    icon:"img/nav_left/ic_appli_DDNS_0.png",
                    iconfont:"icon-dns"
                },
                {
                    name:"UPnP",
                    componentName:"upnp",
                    icon:"img/nav_left/ic_appli_Multicast_0.png",
                    iconfont:"icon-upnp"
                }
            ]
        },
        {
            name:"Management",
            url:"management",
            iconfont:"icon-management",
            twoMenu:[
                {
                    name:"Settings",
                    url:"",
                    icon:"img/nav_left/ic-manage-setting_0.png",
                    iconfont:"icon-settings",
                    thrMenu:[
                        {name:"Backup/Restore",componentName: "backup"},
                        { name: "Reset to Default", componentName:"resetDafult"}
                    ]
                },
                {
                    name:"Account Management",
                    componentName:"reloginpassword",
                    icon:"img/nav_left/ic-manage-accoun_0.png",
                    iconfont:"icon-accout"
                },
                {
                    name:"Tools ",
                    url:"",
                    icon:"img/nav_left/ic-manage-diagnosis_0.png",
                    iconfont:"icon-tool",
                    thrMenu:[
                        { name: "Ping Diagnosis", componentName:"ping"},
                        { name: "Trace Route Diagnosis", componentName:"traceRoute"},
                        { name: "Inform Manually", componentName:"tr069InformStatus"},
                        { name: "WPS Setting", componentName:"wpsSetting"}
                    ]
                }
            ]
        }
    ]
}